import axios from '@/axios/globalaxios';

export const getNetWorthData = data =>{
    return axios({
        url: "/tradelab/openFund/getNetWorthData",
        method: 'post',
        data:data
    })
}